import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import { Country } from '@js/api/types/address/Country'

interface GetCountriesResponse {
  data: {
    country: Country
  }
}

export const getCountryQuery = gql`
  query($countryId: String!) {
    country(id: $countryId) {
      id
      full_name_english
      two_letter_abbreviation
      available_regions {
        code
        name
      }
    }
  }
`

export const getCountry = async (countryId: string): Promise<Country> => {
  const { data }: AxiosResponse<GetCountriesResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Store: getStoreName(),
    },
    data: {
      query: getCountryQuery,
      variables: {
        countryId,
      },
    },
  })

  return data.data.country
}
